import "./Client.css";

const Client = () => {
  return (
    <section className="numbers">
      <div className="continer">
        <div className="row">
          <div className="col-md-3">
            <h1>Frontend Project</h1>
            <h2>7</h2>
          </div>
          <div className="col-md-3">
            <h1>Network Project</h1>
            <h2>15</h2>
          </div>
          <div className="col-md-3">
            <h1>Security Project</h1>
            <h2>22</h2>
          </div>
          <div className="col-md-3">
            <h1>Analysis Project</h1>
            <h2>2</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Client;
